import { useEffect, useState } from "react";
import { downloadMyReport, getMyReports } from "API/myPages";
import { Grid } from "@mui/material";
import ReportTable from "Pages/AdminInterface/reports/ReportTable";
import { usePopupNotificationContext } from "Context/NotificationPopup";

export default function MyPageReports() {
  const [reports, setReports] = useState([]);
  const { openError } = usePopupNotificationContext();

  const asyncFetchMyReports = async () => {
    const data = await getMyReports();
    setReports(data);
  };

  useEffect(() => {
    asyncFetchMyReports();
  }, []);

  const onDownloadReport = async (reportId) => {
    try {
      const report = reports.find((report) => report.Id === reportId);
      const res = await downloadMyReport(report.Id);
      if (res) {
        createDownloadReport(res.data, report);
      }
    } catch (err) {
      console.error(err);
      openError(
        `Någonting gick fel vid hämtning av rapport med id: ${reportId}`,
        3000
      );
    }
  };

  const createDownloadReport = (blob, report) => {
    const fileBlob = new Blob([blob], {
      type:
        report.FileType === "text/plain"
          ? "application/octet-stream"
          : report.FileType,
    });
    const blobUrl = URL.createObjectURL(fileBlob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = `${report.Name}`;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  };

  return (
    <Grid container spacing={2}>
      <ReportTable reports={reports} onDownloadReport={onDownloadReport} />
    </Grid>
  );
}
